<template>
  <div class="driver-info" :style="{height:InfoHeight+'px'}">
    <!--<div class="driver-title">司机信息</div>-->
    <div class="driver-detail" v-if="model.driverName">
      <div class="driver-cloum" style="margin-top: 24px;position: relative">
        <img  :src="getFileAccessHttpUrl(model.headImg || 'https://oss.dimoclub.com/static/driver/default_logo.png')">
        <a-icon type="delete" @click="delDriver" style="position: absolute;margin-left: 70px;color: red;font-size: 18px" v-has="'driver:del'"></a-icon>
      </div>
      <div class="driver-cloum driver-name" :style="{color:model.driverLabel?'#ff0000':''}">{{model.driverName}}</div>
      <div class="driver-cloum driver-number">{{model.idNumber}}</div>
      <div class="driver-cloum driver-city">
        <span v-if="model.areaName" @click="editArea":style="{color:model.areaName!==model.defaultArea?'#ff0000':''}">{{model.areaName}}</span>
        <a v-else @click="editArea">暂未添加城市</a>
      </div>
      <div class="driver-cloum driver-label">
        <span v-if="model.driverLabel" @click="editLabel">{{model.driverLabelStr.length>15?(model.driverLabelStr.substring(0,15)+'...'):model.driverLabelStr}}</span>
        <a v-else @click="editLabel" >暂未添加标签</a>
      </div>
      <div class="driver-cloum driver-sub">
        <a v-if="model.hasSubscribe==-1"   @click="editSubscribe">邀请关注公众号</a>
        <span @click="viewRecord"  :class="model.hasSubscribe==1?'gz':'qg'" v-else>{{model.hasSubscribe==1?'公众号已关注':'公众号已取关'}}</span>
      </div>
    </div>
    <div :style="{height:contentHeight+'px'}" class="driver-overflow">
      <div class="driver-baseinfo">
        <div class="base-item" v-for="item in tabList" :class="item.tab==leftMap.leftTab?'active':''" @click="clickTab(item.tab)">
          <div class="base-title">
            <div class="left-title">{{item.title}}</div>
            <div class="right-count">
              <span class="num" v-if="item.num!=undefined">{{item.num}}</span><span v-if="item.num!=undefined">/</span>
              {{item.total}}</div>
          </div>
          <div class="base-content">
            <img :title="item.realName" :src="getFileAccessHttpUrl(item.headImg || 'https://oss.dimoclub.com/static/driver/defalut_icon.png')" v-if="item.headImg"/>
            <span v-if="item.operateType && item.operateTime">更新于{{item.operateTime}}</span>
            <span v-else>暂无信息</span>
          </div>
        </div>
      </div>
      <div class="driver-join" v-if="model.joinList">
        <div class="join-person">参与人</div>
        <div class="join-img">
          <img :title="img.realName" :src="getFileAccessHttpUrl(img.headImg || 'https://oss.dimoclub.com/static/driver/default_icon.png')" :style="{left:((idx+1)*16)+'px',zIndex:idx+9}" v-for="(img,idx) in model.joinList"/>
        </div>
      </div>
    </div>
    <!--<dm-driver-label-modal  @ok="submitCallback" ref="label"></dm-driver-label-modal>-->
    <dm-driver-label-list @ok="submitCallback" ref="label"></dm-driver-label-list>
    <edit-area-modal ref="editArea" @ok="submitCallback"></edit-area-modal>
    <follow-modal ref="followModal" @ok="submitCallback"></follow-modal>
    <jc-record-modal ref="jcRecord" @ok="submitCallback"></jc-record-modal>
  </div>
</template>

<script>

import { httpAction, getAction ,getFileAccessHttpUrl,deleteAction} from '@/api/manage'
import {initDictOptions, filterDictText} from '@/components/dict/JDictSelectUtil'
import {ajaxGetDictItems,getDictItemsFromCache} from '@/api/api'
import DmDriverLabelModal from "../../../views/dm/dirver/windows/DmDriverLabelModal";
import EditAreaModal from "../../../views/dm3/driver/windows/EditAreaModal";
import DmDriverLabelList from "../../../views/dm3/driver/DmDriverLabelList";
import FollowModal from "../../../views/dm3.0/driver/modules/FollowModal";
import JcRecordModal from "../../../views/dm3.0/driver/modules/JcRecordModal";
export default {
  name: 'DriverInfo',
  components: {JcRecordModal, FollowModal, DmDriverLabelList, EditAreaModal, DmDriverLabelModal},
  props:{
    leftMap:{
      type:Object,
      default: {}
    },
    model:{
      type:Object,
      default: {}
    }
  },
  data() {
    return {
      contentHeight:document.documentElement.clientHeight-380,
      InfoHeight:document.documentElement.clientHeight-128,
      tabListDefault:[
        {
          title:"司机",
          headImg:null,
          operateType:0,
          tab:1,
          operateTime:null
        },
        {
          title:"车辆",
          headImg:null,
          operateType:0,
          tab:2,
          operateTime:null
        },{
          title:"工单",
          headImg:null,
          operateType:0,
          tab:3,
          operateTime:null
        },{
          title:"平台",
          headImg:null,
          operateType:0,
          tab:4,
          operateTime:null
        },{
          title:"呼叫",
          headImg:null,
          operateType:0,
          tab:5,
          operateTime:null
        },
        {
          title:"优惠卷",
          headImg:null,
          operateType:0,
          tab:6,
          operateTime:null
        }
        ,{
          title:"司机附件",
          headImg:null,
          operateType:0,
          tab:7,
          operateTime:null
        }
      ],
      tabList:[],
      getFileAccessHttpUrl:getFileAccessHttpUrl,
      numArr:[0,0,0]
    }
  },methods:{
    edit(){
      this.tabList = [];
      let operateMap = {}
      if(this.model.operateDriverList){
        for(let a in this.model.operateDriverList){
          operateMap[this.model.operateDriverList[a].tab] = this.model.operateDriverList[a];
        }
      }
      this.getNum();
      let href = window.location.href;
      for(let b in this.tabListDefault){
        let v = operateMap[this.tabListDefault[b].tab]
        let tab = Object.assign(this.tabListDefault[b],{});
        // if(this.tabListDefault[b].tab > 4 && href.indexOf("ht.dimoclub.com")==-1){
        //   continue;
        // }
        if(v){
          tab.headImg = v.headImg || 'https://oss.dimoclub.com/static/driver/defalut_icon.png';
          tab.operateType = v.operateType;
          tab.operateTime = v.operateTime;
          tab.realName = v.realName;
        }else{
          tab.headImg = null;
          tab.operateType = b;
          tab.operateTime = null;
        }
        if(b==0){
          tab.num = this.numArr[0];
          tab.total = 6;
        }else if(b==1){
          tab.num = this.model.carCount;
          tab.total =  this.model.carTotalCount;
        }else if(b==2){

          tab.num = this.model.workorderIngCount;
          tab.total =  this.model.workorderCount;
        }else if(b==3){
          tab.num = this.model.platformCount;
          tab.total =  this.model.totalPlatform;
        }else if(b==4){
          tab.total =  this.model.callCount;
        }else if(tab.tab==6){
          tab.total =  this.model.allYhj;
          tab.num =  this.model.unUseYhj;
        }else if(tab.tab==7){
          tab.total =  this.model.allYhj;
        }
        this.tabList.push(tab)
      }

    },clickTab(tab){
      if(tab==6 && this.model.hasSubscribe!=1){
        this.editSubscribe();
        return;
      }
      if(tab==this.leftMap.leftTab && !this.leftMap.page){
        return;
      }
      let tb = this.tabListDefault[tab-1];
      this.$emit('change',{f:"",s:tb.title,page:"",leftTab:tab});
    },editLabel(){
      // this.$refs.label.edit({
      //   id:this.model.id,
      //   driverLabel:this.model.driverLabel
      // })
      this.$refs.label.show(this.model.id);
    },submitCallback(){
      this.$emit("update",1);
    },editArea(){
      this.$refs.editArea.edit(this.model);
    },getNum(){
      let baseNum =0;
      let tnum = 0;
      let moreNum = 0;
      if(this.model.headImg){
        baseNum++;
      }
      if(this.model.idCardBack){
        baseNum++;
      }
      if(this.model.idCardFront){
        baseNum++;
      }
      if(this.model.license&&this.model.license.frontImg){
        baseNum++;
      }
      if(this.model.license&&this.model.license.backImg){
        baseNum++;
      }
      if(this.model.personLicense&&this.model.personLicense.licenseImg){
        baseNum++;
      }
      this.numArr[0] = baseNum;
      if(this.model.personLicense&&this.model.personLicense){
        tnum++;
      }
      this.numArr[1] = tnum;
      if(this.model.enclosureList){
        for(let a in this.model.enclosureList){
          if(this.model.enclosureList[a].imgPath){
            moreNum++
          }
        }
      }
      this.numArr[2] = moreNum;
    },delDriver(){
      this.$confirm({
        title: '提示',
        okText: '确认',
        cancelText: '取消',
        content: '是否确定删除该司机？',
        onOk: () => {
          deleteAction("/dm/dmDriver/delete",{id:this.model.id}).then(res=>{
            if(res.success){
              this.$emit("close")
            }
          })
        },
        onCancel: () => {

        }
      })

    },editSubscribe(){
      this.$refs.followModal.show(this.model.id);
    },viewRecord(){
      this.$refs.jcRecord.show(this.model.id,this.model.hasSubscribe);
    }
  }
}
</script>
<style lang="less" scoped>
.driver-info{
  background: #fff;
  width: 265px;
  border-radius: 12px;
}
.driver-title{
  height: 72px;
  line-height: 72px;
  padding-left: 24px;
  font-size: 16px;
  color:  rgba(10, 22, 41, 1);
  border-bottom: 1px solid rgba(230, 237, 245, 1);

}

.driver-detail{
  text-align: center;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(230, 237, 245, 1);
}

.driver-cloum{
  line-height: 36px;
}
.driver-cloum img{
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.driver-name{
  font-size: 16px;
  color: rgb(10, 22, 41);
}
.driver-number{
  color: rgba(145, 146, 158, 1);
}
.driver-city,.driver-label,.driver-sub{
  font-size: 12px;
  cursor: pointer;
}
.driver-label span,.driver-city span{
  padding: 2px 5px;
}
.driver-city span{
  color: rgba(125, 133, 146, 1);
  border: 1px solid rgba(125, 133, 146, 1);
}
.driver-label span{
  background: rgba(196, 24, 230, 0.12);
  color: rgba(196, 24, 230, 1);
}

.driver-sub span{
  border: 1px solid #43CF7C;
  padding: 3px;
  border-radius: 4px;
}
.driver-sub span.qg{
  border: 1px solid rgba(125, 133, 146, 1);
  color: rgba(125, 133, 146, 1);
}

.driver-sub span.gz{
  border: 1px solid #43CF7C;
  color: #43CF7C;
}

.driver-baseinfo{
  padding: 12px;
  background: #fff;
  border-bottom: 1px solid #e6edf5;
}
.base-item{
  padding: 12px;
  border-radius: 12px;
  cursor: pointer;
}
.base-item.active{
  background: rgba(232, 241, 255, 1);
}

.base-item.active .base-title .left-title{
  color: rgba(24, 144, 255, 1);
}
.base-item .base-title{
  font-size: 16px;
  color: rgb(10, 22, 41);
  display: flex;
  justify-content: space-between;
}
.base-item .base-title .right-count .num{
  color: rgba(24, 144, 255, 1);
}
.base-item .base-content{
  margin-top: 12px;

}
.base-content img{
  width: 24px;
  height: 24px;
  border-radius: 50%;
}
.base-content span{
  color: rgba(145, 146, 158, 1);
  vertical-align: middle;
  margin-left: 3px;
}
.driver-join{
  padding: 24px;
  height: 100px;
  background: #fff;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}
.join-person{
  color: rgba(145, 146, 158, 1);
}
.join-img{
  margin-top: 5px;
  position: relative;
}
.join-img img{
  width: 24px;
  height: 24px;
  border: 2px solid rgba(255, 255, 255, 1);
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
}
.driver-overflow {
  overflow-y: auto;
}

.driver-overflow::-webkit-scrollbar{
  width: 0px;
}

.driver-overflow:hover::-webkit-scrollbar{
  width: 8px;
}
</style>